import {JsonData} from "@/Fwk/Kit/JsonData";

export class RiskBean {
    scene = 0;
    isDef = 0; // is_def: 是否兜底 1-采用兜底配置并被禁止  2-采用兜底配置未被禁止  3-没有采用兜底配置
    defRule = "";
    restrict = 0;
    result: JsonData;

    constructor(scene: number,
                isDef: number,
                defRule: string,
                restrict: number,
                result: JsonData) {
        this.scene = scene;
        this.isDef = isDef;
        this.defRule = defRule;
        this.restrict = restrict;
        this.result = result;
    }
}
